import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { Button } from '../../components/ui/Button.jsx';
import { Modal } from '../../components/ui/Modal.jsx';
import { useTranslation } from '../../i18n/useTranslation.js';
import { financeApi } from '../../services/financeApi.js';

const today = () => new Date().toISOString().slice(0, 10);

export function PaymentRunCreateModal({ open, onClose, onCreated }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [form, setForm] = useState({ paymentDate: today(), dueBy: today() });
  const [error, setError] = useState(null);

  useEffect(() => { if (open) { setForm({ paymentDate: today(), dueBy: today() }); setError(null); } }, [open]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = useMutation({
    mutationFn: (body) => financeApi.createPaymentRun(body),
    onSuccess: (run) => {
      queryClient.invalidateQueries({ queryKey: ['finance', 'payment-runs'] });
      onClose();
      if (run?.id) onCreated?.(run.id);
    },
    onError: (err) => setError(err?.message || t('common.loadError')),
  });

  function submit(e) {
    e.preventDefault();
    setError(null);
    if (!form.paymentDate || !form.dueBy) { setError(t('pr.error.required')); return; }
    save.mutate({ paymentDate: form.paymentDate, dueBy: form.dueBy });
  }

  return (
    <Modal open={open} onClose={onClose} title={t('pr.modal.title')}
      footer={<><Button variant="ghost" onClick={onClose}>{t('common.cancel')}</Button>
        <Button variant="primary" onClick={submit} disabled={save.isPending}>{save.isPending ? `${t('pr.modal.creating')}…` : t('pr.modal.propose')}</Button></>}>
      <form onSubmit={submit} className="form-stack">
        <p className="muted text-sm">{t('pr.modal.hint')}</p>
        <div className="field-row">
          <label className="field">
            <span className="field-label">{t('pr.col.paymentDate')}</span>
            <input className="input" type="date" value={form.paymentDate} onChange={set('paymentDate')} required />
          </label>
          <label className="field">
            <span className="field-label">{t('pr.field.dueBy')}</span>
            <input className="input" type="date" value={form.dueBy} onChange={set('dueBy')} required />
          </label>
        </div>
        {error && <div className="alert danger">{error}</div>}
      </form>
    </Modal>
  );
}
